<!--  -->
<template>
  <div>
    <ul class="lit03">
      <li v-for="item in productNav" :key="item.title">
        <div class="cont_r_b04">
          <div class="cont_r_b05">
            <img :src="item.img" width="158" height="109">
          </div>
          <div class="cont_r_b06">
            <div class="cont_r_b07">
              <p></p>
            </div>
            <div class="cont_r_b09">
              <p></p>
              <p>
                <span style="font-family:&quot;color:black;">
                  <strong>
                    <u>{{item.title}}</u>
                  </strong>
                </span>
              </p>
              <p>
                <span style="font-family:&quot;color:black;">
                  <span></span>
                </span>
                <span style="font-family:&quot;color:black;">
                  <br>
                </span>
              </p>
              <p style="font-family:&quot;color:black;" v-html="item.word"></p>
              <p></p>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      productNav: [
        {
          title: "NON-FERROUS METALS",
          word:
            "Brass Ingot (LS59,LS60,M70), Bronze Ingot (BrO312), Copper Ingot (M98,M99),Aluminum Coil,Aluminum Plate,Aluminum Foil(1 xxx, 3 xxx, 5 xxx),Can Body MaterialRemelt Lead Ingot(Grade #1,# 2),Remelt Zinc Ingot(Grade #1,# 2)",
          img: require("../../../assets/img/common/home1.jpg")
        },
        {
          title: "MINERALS,RARE-EARTH & FERRO-ALLOYS",
          word:
            "Cr Ore(Grade:Cr32%,Cr36%,Cr42%),Mn Ore Mischmetal<br />RE Silicide(Re30%, Re10%)<br />Si Metal(Grade 553,441,3303,2202)<br />FeNi(Ni10%,Ni20%,Ni50%),FeSi(FeSi75%,FeSi72%,FeSi65%),FeMn,FeSiMn,FeMo,FeCr,FeTi,FeV",
          img: require("../../../assets/img/common/home2.jpg")
        },
        {
          title: "CARBON PRODUCTS & METALLURGICAL COAL",
          word:
            "Electrode (Carbon: Φ800mm - 1272mm, Graphite: Φ800mm - 1146mm)Carbon Block, Anode, Electrode Paste, Graphite Block, Calcined Coke Calcined Coal, Metallurgical Coal",
          img: require("../../../assets/img/common/home3.jpg")
        },
        {
          title: "MEDICINES & HEALTH PRODUCTS",
          word:
            "Huperzine A,Tea Extract,Theaflavin,Instant Tea,Pueraria Extract,Milk Thistle P.E,Grape Seed Extract,Chondroitin Sulfate,Glucosamine Sulfate 2KCl,Glucosamine HCl,L- Carnitine,L-Tyrosine,L-Arginine,Alpha Lipoic Acid",
          img: require("../../../assets/img/common/home4.jpg")
        },
        {
          title: "CHEMICALS",
          word:
            "Titanium Dioxide,Sodium Carbonate Anhydrous,Aluminium Fluoride,Synthetic Cryolite",
          img: require("../../../assets/img/common/home5.jpg")
        },
        {
          title: "RAW MATERIALS & STEEL PRODUCTS",
          word:
            "Mn Lumpy (Mn95%min), Mn Flake (Mn99.7%min), Mn Briquettes (Mn97%min)<br />Mg Ingots, Mg Granulars (Mg99.9% min, Mg 97%+CaO 3%), Calcium Granulars (Ca98.5%min)<br />Cored-wire",
          img: require("../../../assets/img/common/home6.gif")
        }
      ]
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/product/productsy.vue